var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveyPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 135,
    viewBox: "0 0 129 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 45,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#F8F2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29890_73239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.575 59.6H67.2C67.2 58.1235 65.9766 56.9001 64.5 56.9001C62.9813 56.9001 61.8 58.1235 61.8 59.6H58.425C57.2859 59.6 56.4 60.5282 56.4 61.625V76.475C56.4 77.6141 57.2859 78.5 58.425 78.5H70.575C71.6719 78.5 72.6 77.6141 72.6 76.475V61.625C72.6 60.5282 71.6719 59.6 70.575 59.6ZM60.45 74.7875C59.8594 74.7875 59.4375 74.3657 59.4375 73.775C59.4375 73.2266 59.8594 72.7625 60.45 72.7625C60.9984 72.7625 61.4625 73.2266 61.4625 73.775C61.4625 74.3657 60.9984 74.7875 60.45 74.7875ZM60.45 70.7375C59.8594 70.7375 59.4375 70.3157 59.4375 69.725C59.4375 69.1766 59.8594 68.7125 60.45 68.7125C60.9984 68.7125 61.4625 69.1766 61.4625 69.725C61.4625 70.3157 60.9984 70.7375 60.45 70.7375ZM60.45 66.6875C59.8594 66.6875 59.4375 66.2657 59.4375 65.675C59.4375 65.1266 59.8594 64.6625 60.45 64.6625C60.9984 64.6625 61.4625 65.1266 61.4625 65.675C61.4625 66.2657 60.9984 66.6875 60.45 66.6875ZM64.5 58.5876C65.0484 58.5876 65.5125 59.0516 65.5125 59.6C65.5125 60.1907 65.0484 60.6125 64.5 60.6125C63.9094 60.6125 63.4875 60.1907 63.4875 59.6C63.4875 59.0516 63.9094 58.5876 64.5 58.5876ZM69.9 74.1125C69.9 74.3235 69.7312 74.45 69.5625 74.45H63.4875C63.2766 74.45 63.15 74.3235 63.15 74.1125V73.4375C63.15 73.2688 63.2766 73.1 63.4875 73.1H69.5625C69.7312 73.1 69.9 73.2688 69.9 73.4375V74.1125ZM69.9 70.0625C69.9 70.2735 69.7312 70.4 69.5625 70.4H63.4875C63.2766 70.4 63.15 70.2735 63.15 70.0625V69.3875C63.15 69.2188 63.2766 69.05 63.4875 69.05H69.5625C69.7312 69.05 69.9 69.2188 69.9 69.3875V70.0625ZM69.9 66.0125C69.9 66.2235 69.7312 66.35 69.5625 66.35H63.4875C63.2766 66.35 63.15 66.2235 63.15 66.0125V65.3375C63.15 65.1688 63.2766 65 63.4875 65H69.5625C69.7312 65 69.9 65.1688 69.9 65.3375V66.0125Z",
    fill: "#A0438B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29890_73239",
    x: 0.148438,
    y: 0.650024,
    width: 128.703,
    height: 134.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29890_73239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29890_73239",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyPink);
export default __webpack_public_path__ + "static/media/survey-pink.0ad37a20.svg";
export { ForwardRef as ReactComponent };